import { IRcsConfig, IRcsPreviewCompilationContext } from './context/useRcsTemplateEditorContext';

export const DEFAULT_RCS_ACTION_ID = 'default-1';

export const DEFAULT_SNAPSHOT_JSON = JSON.stringify(
  {
    compilationContext: {
      unsubscribeUrl: 'https://example.com/unsubscribe',
      pixelUrl: 'https://example.com/pixel',
      year: '2025',
      sendOverride: 'default',
      customer: {
        firstName: 'Alex',
        lastName: 'Smith',
        salutation: 'Hi',
        id: 'cust-123',
        loggedIn: true,
        hasLoggedIn: true,
        type: 'registered',
        marketingStatus: 'opted_in',
        dob: '1990-01-15',
        optIns: { email: true, hasEmail: true },
        address: {
          line1: '123 High Street',
          line2: 'Apt 4',
          city: 'London',
          country: 'United Kingdom',
          county: 'Greater London',
          postcode: 'SW1A 1AA',
          freeText: '',
        },
      },
      email: { value: 'alex.smith@example.com', source: 'profile' },
      phone: { landline: '', mobile: '+44 7700 900000', source: 'profile' },
      geoLocation: {
        continentCode: 'EU',
        countryCode: 'GB',
        countryName: 'United Kingdom',
      },
      locale: { code: 'en-GB', language: 'en', region: 'GB' },
      device: { device: { type: 'mobile' } },
      abandonedBasket: {
        currency: 'GBP',
        currencySymbol: '£',
        paymentType: 'card',
        type: 'abandoned',
        repopulationUrl: 'https://example.com/cart/restore',
        sendOverride: 'default',
        discount: {
          label: 'SAVE10',
          code: 'SAVE10',
          cost: { currency: 'GBP', currencySymbol: '£', decimal: '10.00', stripped: '10', text: '£10.00' },
        },
        shipping: {
          label: 'Standard',
          value: 'standard',
          cost: { currency: 'GBP', currencySymbol: '£', decimal: '4.99', stripped: '4.99', text: '£4.99' },
          address: {
            line1: '123 High Street',
            line2: '',
            city: 'London',
            country: 'United Kingdom',
            county: 'Greater London',
            postcode: 'SW1A 1AA',
            freeText: '',
          },
        },
        costs: {
          subtotal: { currency: 'GBP', currencySymbol: '£', decimal: '89.00', stripped: '89', text: '£89.00' },
          total: { currency: 'GBP', currencySymbol: '£', decimal: '83.99', stripped: '83.99', text: '£83.99' },
          taxes: {},
          claim: { currency: 'GBP', currencySymbol: '£', decimal: '0', stripped: '0', text: '£0.00' },
        },
        items: [
          {
            quantity: '1',
            product: {
              name: 'Blue running shoes',
              url: 'https://example.com/product/blue-shoes',
              description: 'Lightweight running shoes',
              currency: 'GBP',
              currencySymbol: '£',
              brand: 'RunFast',
              inStock: true,
              isLowStock: false,
              clientProductId: 'prod-456',
              metricId: 'revenue',
              metricValue: '89.00',
              images: { thumbnail: 'https://example.com/images/shoe-thumb.jpg', additional: {} },
              costs: {
                singleItem: {
                  currency: 'GBP',
                  currencySymbol: '£',
                  decimal: '89.00',
                  stripped: '89',
                  text: '£89.00',
                },
                previous: {
                  currency: 'GBP',
                  currencySymbol: '£',
                  decimal: '99.00',
                  stripped: '99',
                  text: '£99.00',
                },
                taxes: {},
                discount: {},
                shipping: {},
                contract: {},
              },
              color: { label: 'Colour', value: 'Blue' },
              size: { label: 'Size', value: 'UK 9' },
              category: {
                id: 'cat-1',
                label: 'Footwear',
                value: 'footwear',
                hierarchy: ['Sports', 'Running'],
              },
              rating: { label: 'Rating', value: '4.5' },
              accommodation: {},
              journey: [],
              ticket: {},
            },
            costs: {
              subtotal: { currency: 'GBP', currencySymbol: '£', decimal: '89.00', stripped: '89', text: '£89.00' },
              total: { currency: 'GBP', currencySymbol: '£', decimal: '89.00', stripped: '89', text: '£89.00' },
              taxes: {},
              claim: { currency: 'GBP', currencySymbol: '£', decimal: '0', stripped: '0', text: '£0.00' },
            },
            subItems: null,
            clientRecommendations: [],
          },
        ],
      },
      browsedProducts: [],
      purchasedBaskets: [],
      purchasedRecommendations: [],
      clientRecommendations: [],
    },
  },
  null,
  2,
);

export const defaultRcsConfig: IRcsConfig = {
  imageUrl: '',
  cardTitle: '',
  description: '',
  actions: [
    {
      id: DEFAULT_RCS_ACTION_ID,
      actionType: 'openUrl',
      buttonLabel: '',
      actionUrl: '',
    },
  ],
  smsFallbackEnabled: false,
};

export const defaultRcsPreviewCompilationContext: IRcsPreviewCompilationContext = {
  customer: { firstName: 'John' },
  phone: { mobile: '+447700000000' },
};
